import { ManagePackagesCountStatusTypes, ManagePackagesCountStatusActionTypes } from "./managePackagesCountStatusTypes";
import { QuoteCountStatusRequest } from "@/main/models/request/quoteRequest";
import { QuoteResponseCount } from "@/main/models/response";

export function getManagePackagesCountStatus(request: QuoteCountStatusRequest): ManagePackagesCountStatusActionTypes {
	return {
		type: ManagePackagesCountStatusTypes.GET_MANAGEPACKAGES_COUNT_STATUS,
		payload: {
			request: request,
		},
	};
}

export function saveManagePackagesCountStatus(
	data: QuoteResponseCount[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): ManagePackagesCountStatusActionTypes {
	return {
		type: ManagePackagesCountStatusTypes.SAVE_MANAGEPACKAGES_COUNT_STATUS,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerManagePackagesCountStatus(): ManagePackagesCountStatusActionTypes {
	return {
		type: ManagePackagesCountStatusTypes.RESET_REDUCER_MANAGEPACKAGES_COUNT_STATUS,
	};
}
